import Api from "../../../../shared/services/api"
import { AppConfig } from "../app-config";


export const upsertAppConfigs = async (appConfig: AppConfig): Promise<void> => {
    const result = await Api.post(`/upsertappconfig`, appConfig);
    return result.data;
}

export const getAppConfigs = async (): Promise<AppConfig[]> => {
    const result = await Api.get(`/appconfigs/`);
    return result.data;
}